var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.fotoUrl)?_c('v-img',{class:_vm.classAvatar,attrs:{"src":"/images/avatares/avatar-padrao.png","aspect-ratio":"4/3"}}):_c('v-img',{class:_vm.classAvatar,attrs:{"src":_vm.createUrl(_vm.fotoUrl),"aspect-ratio":"4/3","lazy-src":"/images/loading.gif"}})
}
var staticRenderFns = []

export { render, staticRenderFns }